(function () {
  var MOBILE_QUERY = '(max-width: 699px)';
  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  var ADVANCE_DELAY = 5600;
  var RESUME_DELAY = 8000;

  function init(section) {
    if (section.dataset.testimonialWallReady === 'true') return;

    var viewport = section.querySelector('[data-testimonial-viewport]');
    var cards = Array.from(section.querySelectorAll('[data-testimonial-card]'));
    var previous = section.querySelector('[data-testimonial-prev]');
    var next = section.querySelector('[data-testimonial-next]');
    var pause = section.querySelector('[data-testimonial-pause]');
    var status = section.querySelector('[data-testimonial-status]');
    if (!viewport || cards.length < 2 || !previous || !next || !pause) return;

    section.dataset.testimonialWallReady = 'true';

    var mobile = window.matchMedia(MOBILE_QUERY);
    var reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);
    var index = 0;
    var timer = 0;
    var resumeTimer = 0;
    var scrollTimer = 0;
    var userPaused = false;

    function cardLeft(card) {
      var inset = parseFloat(getComputedStyle(viewport).paddingLeft || 0);
      return Math.max(0, card.offsetLeft - inset);
    }

    function updateStatus() {
      if (status) status.textContent = 'Review ' + (index + 1) + ' of ' + cards.length;
    }

    function nearestIndex() {
      var target = viewport.scrollLeft;
      var nearest = 0;
      var distance = Infinity;

      cards.forEach(function (card, cardIndex) {
        var nextDistance = Math.abs(cardLeft(card) - target);
        if (nextDistance < distance) {
          nearest = cardIndex;
          distance = nextDistance;
        }
      });

      index = nearest;
      updateStatus();
    }

    function goTo(nextIndex, smooth) {
      if (!mobile.matches) return;
      index = (nextIndex + cards.length) % cards.length;
      viewport.scrollTo({
        left: cardLeft(cards[index]),
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      updateStatus();
    }

    function stop() {
      window.clearTimeout(timer);
      timer = 0;
    }

    function schedule() {
      stop();
      if (!mobile.matches || reducedMotion.matches || userPaused || document.hidden) return;
      timer = window.setTimeout(function () {
        goTo(index + 1, true);
        schedule();
      }, ADVANCE_DELAY);
    }

    function hold() {
      stop();
      window.clearTimeout(resumeTimer);
      if (!userPaused) resumeTimer = window.setTimeout(schedule, RESUME_DELAY);
    }

    previous.addEventListener('click', function () {
      hold();
      goTo(index - 1, true);
    });

    next.addEventListener('click', function () {
      hold();
      goTo(index + 1, true);
    });

    pause.addEventListener('click', function () {
      userPaused = !userPaused;
      pause.textContent = userPaused ? 'Play' : 'Pause';
      pause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      userPaused ? stop() : schedule();
    });

    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(function (eventName) {
      viewport.addEventListener(eventName, hold, { passive: eventName !== 'keydown' });
    });

    viewport.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(nearestIndex, 140);
    }, { passive: true });

    function refresh() {
      stop();
      window.clearTimeout(resumeTimer);
      if (mobile.matches) {
        nearestIndex();
        schedule();
      }
    }

    if (mobile.addEventListener) mobile.addEventListener('change', refresh);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', refresh);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('resize', nearestIndex, { passive: true });

    updateStatus();
    schedule();
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-testimonial-wall]')) init(scope);
    scope.querySelectorAll('[data-testimonial-wall]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
